import { VoohCreation, VoohMediaFormat } from '../../VoohCampaignForm/types'

export type VoohGroupedCreations = {
  [key in VoohMediaFormat]: VoohCreation[]
}

export const groupedVoohCreationsDefault = (): VoohGroupedCreations => ({
  move_tv: [],
})
